import { Description } from '@zenterprise-inc/ui';
import { useAtomValue } from 'jotai';
import { useRouter } from 'next/router';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';

import { businessIntroQuery } from '@/__generated__/businessIntroQuery.graphql';
import common from '@/components/survey/common/ui/styles/common.module.scss';
import { introQuery } from '@/graphql/query/survey/business';
import { SURVEY_PAGES } from '@/lib/constants/paths';
import { hasEmployeeAtom, imputedYearAtom } from '@/lib/stores/survey/common';

export const SurveyIntroContainer = ({ queryRef }: { queryRef: PreloadedQuery<businessIntroQuery> }) => {
  const router = useRouter();
  const { getSurveyBusinessInfo } = usePreloadedQuery<businessIntroQuery>(introQuery, queryRef);
  const imputedYear = useAtomValue(imputedYearAtom);
  const hasEmployee = useAtomValue(hasEmployeeAtom);

  const businessName = getSurveyBusinessInfo.business?.[0]?.tnm || getSurveyBusinessInfo.business?.[0]?.bsno || '';

  return (
    <main>
      <div
        className={common.intro_vh}
        onAnimationEnd={() => {
          setTimeout(() => {
            const openingDate = getSurveyBusinessInfo.business?.[0]?.ofbDt || '';
            const isWithin8Years = isOpeningDateWithin8Years(openingDate, Number(imputedYear));

            if (isWithin8Years) {
              router.replace(SURVEY_PAGES.직업창업);
              return;
            }
            if (hasEmployee) {
              router.replace(SURVEY_PAGES.승계직원);
              return;
            }
            router.replace(SURVEY_PAGES.사업장_근무여부);
          }, 2000);
        }}
      >
        <Description.Guide titleSize={'large'} title={`${businessName}에 대한 질문을 먼저 시작할게요`} />
      </div>
    </main>
  );
};

const isOpeningDateWithin8Years = (openingDate: string, imputedYear: number): boolean => {
  if (!openingDate || openingDate.length < 4) {
    return false;
  }
  const openingYear = parseInt(openingDate.substring(0, 4), 10);
  return imputedYear - openingYear <= 8;
};
